import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { GlobalFocusToggle } from '@els/els-react--utils';
import HeaderComponentContainer from '@Containers/Header/HeaderComponentContainer';
import Footer from '@Components/Footer';
import ContentClickManager from '@Components/ContentClickManager';

import './Page.scss';

export default function Page({
  id,
  withSubTabs = false,
  withHeader = false,
  withFooter = true,
  headerType,
  pageClassName,
  className,
  children,
}) {
  return (
    <ContentClickManager>
      <GlobalFocusToggle>
        {withHeader && <HeaderComponentContainer type={headerType} />}
        <section id={id} className={classnames([pageClassName, 'react-page'])}>
          <section
            className={classnames('react-page--children-wrapper', className, {
              'react-page--sub-tabs-padding': withSubTabs,
            })}>
            {children}
          </section>
          {withFooter && <Footer className="react-page-footer" />}
        </section>
      </GlobalFocusToggle>
    </ContentClickManager>
  );
}

Page.propTypes = {
  id: PropTypes.string,
  className: PropTypes.string,
  withHeader: PropTypes.bool,
  headerType: PropTypes.string,
  withFooter: PropTypes.bool,
  withSubTabs: PropTypes.bool,
  pageClassName: PropTypes.string,
  children: PropTypes.node,
};
